import SddSection from 'components/Checkout/Sections/SddSections/SddSection/SddSection';
import withSddSectionProps from 'viewModel/checkout/sections/sddSections/sddSection/withSddSectionProps';

const SddSectionWithProps = withSddSectionProps(SddSection);

export default SddSectionWithProps;
